export default (e) => {
  console.error(e);
};
